import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../hooks/redux';
import { fetchConversations } from '../store/slices/messagesSlice';
import './Conversations.css';

const Conversations: React.FC = () => {
  const dispatch = useAppDispatch();
  const { conversations, loading } = useAppSelector((state) => state.messages);

  useEffect(() => {
    dispatch(fetchConversations({}));
  }, [dispatch]);

  const formatTime = (dateString: string | null) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now.getTime() - date.getTime();
    const diffHours = diffMs / (1000 * 60 * 60);

    if (diffHours < 24) {
      return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    }
    if (diffHours < 168) {
      return date.toLocaleDateString([], { weekday: 'short' });
    }
    return date.toLocaleDateString([], { month: 'short', day: 'numeric' });
  };

  return (
    <div className="conversations">
      <header className="conversations-header">
        <h2>Messages</h2>
      </header>

      {loading && <div className="loading-state">Loading conversations...</div>}

      {!loading && conversations.length === 0 && (
        <div className="empty-state">
          <p>No conversations yet</p>
          <small>Visit a user's profile to start a conversation</small>
        </div>
      )}

      <div className="conversations-list">
        {conversations.map((conv) => (
          <Link
            key={conv.id}
            to={`/messages/${conv.id}`}
            className="conversation-item"
          >
            <img
              src={conv.other_user.avatar_url || `https://api.dicebear.com/7.x/avataaars/svg?seed=${conv.other_user.username}`}
              alt={conv.other_user.display_name || conv.other_user.username}
              className="conversation-avatar"
            />
            <div className="conversation-content">
              <div className="conversation-top">
                <div className="conversation-user">
                  <span className="conversation-name">
                    {conv.other_user.display_name || conv.other_user.username}
                  </span>
                  <span className="conversation-username">@{conv.other_user.username}</span>
                  {conv.other_user.country && (
                    <span className="conversation-country">{conv.other_user.country}</span>
                  )}
                </div>
                <span className="conversation-time">{formatTime(conv.last_message_at)}</span>
              </div>
              <div className="conversation-bottom">
                <p className="conversation-preview">
                  {conv.last_message?.content || 'No messages yet'}
                </p>
                {conv.unread_count > 0 && (
                  <span className="unread-badge">{conv.unread_count}</span>
                )}
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Conversations;
